import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddComponent } from './add/add.component';
import { Update } from './update';
import { FormsModule } from '@angular/forms';

import { User } from './user';
import { UserService } from './user.service';
import { PermissionsComponent } from './permissions/permissions.component';
import { Permissions } from './permissions';


@Component({
    selector: 'app-user',
    imports: [
    FormsModule
],
    templateUrl: './user.component.html',
    styleUrl: './user.component.scss'
})
export class UserComponent {
  users: User[] = []
  permissions: Permissions[] = []

 constructor(public dialog: MatDialog, private userService: UserService) { }

 ngOnInit() {
  this.userService.getUsers().subscribe((users) => {
    this.users = users
    this.fillPermissions()
  })
  this.userService.getPermissions().subscribe((permissions) => {
    this.permissions = permissions
    this.fillPermissions()
  })
 }

 fillPermissions() {
  for (let user of this.users) {
    let userPermissions = user.permissions
    user.permissions = []
    for (let permission of this.permissions) {
      permission.userPermissionId  = userPermissions.some(p => p.permissionId === permission.permissionId)
      user.permissions.push({... permission})
    }
  }
 }

 openDialog() {
  const dialogRef = this.dialog.open(AddComponent, {
    data: {
      user: {
        firstName: "",
        lastName: "",    
        email: "",    
        phoneNumber: ""
      },
      permissions: [],
      saveLabel: "Add"
    }
  })
  dialogRef.afterClosed().subscribe( (result: Update) => {
    console.log(result)
    this.userService.addUser(result.user).subscribe((result) => console.log(result))
  })
 }

  editUser(user: User) {
    const dialogRef = this.dialog.open(AddComponent, {
      data: { 
        user: user,
        saveLabel: "Edit"
      }
    })
    dialogRef.afterClosed().subscribe( (result: Update) => {
      console.log(result)
      this.userService.updateUserInformation(result.user).subscribe((result) => console.log(result))
    })  
  }

  editPermissions(user: User) {
    console.log(user)
    const dialogRef = this.dialog.open(PermissionsComponent, {
      data: user
    })
    dialogRef.afterClosed().subscribe( (result: User) => {
      const id = result.id as number
      if (id) {
        this.userService.updateUserPermissions(id, result.permissions).subscribe((result) => console.log(result))
      }
    })
  }
}

// $(() => {
//   initializeAddUserModalEventHandlers();
//   initializeUserPermissionsSelectPickerEventHandlers();
//   initializeEditButtonEventHandlers();

//   function initializeAddUserModalEventHandlers() {
//     $('#add-user').colorbox({
//       inline: true, 
//       width: '50%'
//     });
  
//     $('.close-modal-button').click(function() {
//       $.colorbox.close();
//     });
  
//     $('#add-user-form').on('submit', function(event) {
//       event.preventDefault();
//       $('#add-user-form button[type=submit]').prop('disabled', true);
      
//       let isValid = true;
  
//       $(this).find('input').each(function(){
//         const noValue = !$(this).val();
//         const isRequired = $(this).prop('required');
//         const isInvalid = isRequired && noValue;
  
//         if (isInvalid) {
//           isValid = false;
//         }
//         $(this).toggleClass('is-invalid', isInvalid);
//       });
  
//       const emailValue = $('#email').val() as string | null; // Add type assertion here
//       const isValidEmail = emailValue?.match(/.+@.+\..+/);
//       if (isValidEmail == null){
//         isValid = false;
//         $('#email').addClass('is-invalid');
//       }
  
//       if (isValid) {
//         $.ajax({
//           dataType: 'json',
//           method: 'POST',
//           url: '/server/management/users/users.php',
//           data: {
//             action: 'addUser',
//             firstName: $('#firstName').val(),
//             lastName: $('#lastName').val(),
//             email: $('#email').val(),
//             phoneNumber: $('#phone').val() || ''
//           },
//           success: function(response) {
//             $('#add-user-form button[type=submit]').prop('disabled', false);
//             if (!response || !response.success) {
//               alert(response.error || 'There was an error adding the user. Please refresh the page and try again.');
//               return;
//             }
  
//             // Clear inputs
//             $('#add-user-form input').val('');
//             $.colorbox.close();
            
//             this.refreshUserTable();
//           }
//         });
//       } else {
//         $('#add-user-form button[type=submit]').prop('disabled', false);
//       }
//     });
//   };
//   function initializeUserPermissionsSelectPickerEventHandlers() {
//     $('#user-management-table').on('changed.bs.select', '.userPermissionsSelectPicker', function(event){
//       const userId = $(this).parents('tr').data('user-id');
  
//       // permissions to be removed - all non-selected options with set ids
//       const removePermissionArr = $(this).children('option:not(:selected)[data-userPermissionId]').map(function(index, ele){
//         return ele.dataset['userpermissionid']; // note this is case-sensitive and should be all lowercase
//       }).get();
//       // permissions to be added - all selected options w/o ids
//       const addPermissionArr = $(this).children('option:selected:not([data-userPermissionId])').map(function(index, ele){
//         return (<HTMLInputElement>ele).value;
//       }).get();
  
//       $.ajax({
//         dataType: 'json',
//         method: 'POST',
//         url: '/server/management/users/users.php',
//         data: {
//           action: 'updateUserPermissions',
//           userId: userId,
//           removePermissionArr: removePermissionArr,
//           addPermissionArr: addPermissionArr
//         },
//         success: function(response){
//           if (!response  || !response.success) {
//             alert(response.error || 'There was an error updating the permissions. Please refresh the page and try again');
//           }
//           refreshUserTable();
//         }
//       });
//     });
//   };
//   function initializeEditButtonEventHandlers() {
//     // Initialize the modal handlers
//     $('.close-modal-button').click(function() {
//       $.colorbox.close();
//     });
  
//     // Initialize the edit button handlers
//     $('#user-management-table').on('click', '.userEditButton', function(event) {
//       event.preventDefault();
  
//       // Initialize the colorbox
//       $('#user-management-table .userEditButton').colorbox({
//         inline: true,
//         width: '50%'
//       });
  
//       // Get user information
//       const userId = $(this).parents('tr').data('user-id');
//       getUserInformation(userId).then((userData) => {
//         $('#editFirstName').val(userData.firstName);
//         $('#editLastName').val(userData.lastName);
//         $('#editEmail').val(userData.email);
//         $('#editPhoneNumber').val(userData.phoneNumber);
//       });
      
//       // Submit user information
//       $('#edit-user-form').on('submit', function(event) {
//         event.preventDefault();
//         $('#edit-user-form button[type=submit]').prop('disabled', true);
  
//         let isValid = true;
//         $(this).find('input').each(function() {
//           const noValue = !$(this).val();
//           const isRequired = $(this).prop('required');
//           const isInvalid = isRequired && noValue;
          
//           if (isInvalid) {
//             isValid = false;
//           }
//           $(this).toggleClass('is-invalid', isInvalid);
//         });
  
//         const emailValue = $('#editEmail').val() as string | null; // Add type assertion here
//         const isValidEmail = emailValue?.match(/.+@.+\..+/);
//         if (isValidEmail == null) {
//           isValid = false;
//           $('#editEmail').addClass('is-invalid');
//         }
  
//         if (isValid) {
//           const newFirstName = $('#editFirstName').val() as string;
//           const newLastName = $('#editLastName').val() as string;
//           const newEmail = $('#editEmail').val() as string;
//           const newPhoneNumber = $('#editPhoneNumber').val() as string;
  
//           updateUserInformation(userId, newFirstName, newLastName, newEmail, newPhoneNumber).then(() => {
//             $.colorbox.close();
//             $('#edit-user-form button[type=submit]').prop('disabled', false);
//             refreshUserTable();
//           });
  
//           // Need to remove the event handlers so that multiple don't exist after submitting the form
//           $(this).off();
//         } else {
//           $('#edit-user-form button[type=submit]').prop('disabled', false);
//         }
//       });
//     });
//   };
//   function getUserInformation(userId: number) {
//     return $.ajax({
//       dataType: 'json',
//       method: 'GET',
//       url: '/server/management/users/users.php',
//       data: {
//         action: 'getUserInformation',
//         userId: userId
//       }
//     }).then((response) => {
//       if (!response || !response.success) {
//         alert(response.error || 'There was an error fetching user data. Please refresh the page and try again.');
//         return;
//       }
  
//       return response.user;
//     });
//   };
//   function updateUserInformation(userId: number, newFirstName: string, newLastName: string, newEmail: string, newPhoneNumber: string) {
//     return $.ajax({
//       dataType: 'json',
//       method: 'POST',
//       url: '/server/management/users/users.php',
//       data: {
//         action: 'updateUserInformation',
//         userId: userId,
//         firstName: newFirstName,
//         lastName: newLastName,
//         email: newEmail,
//         phoneNumber: newPhoneNumber
//       }
//     }).then((response) => {
//       if (!response || !response.success) {
//         alert(response.error || 'There was an error fetching the data. Please refresh the page.');
//       }
//     });
//   };
//   function refreshUserTable() {
//     $.ajax({
//       dataType: 'json',
//       method: 'POST',
//       url: '/server/management/users/users.php',
//       data: {
//         action: 'getUserTable'
//       },
//       success: function(response){
//         if (!response || !response.success) {
//           alert(response.error || 'There was an error fetching the data. Please refresh the page.');
//           return;
//         }
        
//         $('#user-management-table').html(response.table);
//         // $('#user-management-table .userPermissionsSelectPicker').selectpicker({
//         //   iconBase: '',
//         //   tickIcon: 'fas fa-check',
//         //   multipleSeparator: ', <br>'
//         // });
//         $('.dropdown-toggle').on('click', function(){
//           // Set up event listener for clicks outside of the element
//           // $(document).on('click.dropdown', function(e){
//           //   var container = $('.bootstrap-select.open');
//           //   // If the click is not on a child element
//           //   if (container.has(e.target).length === 0) {
//           //     container.removeClass('open');
//           //     $(document).off('click.dropdown');
//           //   }
//           // });
//           // Close all dropdowns
//           $('.bootstrap-select.open').removeClass('open');
//           // Open this dropdown
//           $(this).parent().toggleClass('open');
//         });
//         $('.dropdown-toggle').siblings('select').hide();
//       }
//     });
//   };
// })
